import { LunaError } from '@vlabs/api-bindings/src/luna-client/LunaError';
import type { AxiosRequestConfig, AxiosResponse } from 'axios';

import { createAxiosInstance } from './base-client';

const AXIOS_INSTANCE = createAxiosInstance({
  baseURL: import.meta.env.VITE_STREAMS_API_URL,
});

AXIOS_INSTANCE.interceptors.response.use(
  (response) => response,
  async (error) => {
    if (
      error?.response?.data?.error_code
          && error?.response?.data?.desc
          && error?.response?.data?.detail
          && error?.response?.data?.link
    ) {
      return Promise.reject(new LunaError(error));
    }
    return Promise.reject(error);
  },
);

// The mutator function
export const streamsAxiosClient = async <T>(
  config: AxiosRequestConfig,
  options?: AxiosRequestConfig, // Optional: capture additional options
): Promise<T> => {
  // console.log(config, options);
  return AXIOS_INSTANCE({
    ...config,
    ...options,
  }).then((response: AxiosResponse<T>) => response.data);
};
